import { initMenu } from './menu'
import { initHeader } from './header'
import { initEnquirePage } from './enquire-page'
import { initModalIframe } from './modal-iframe'




var initApp = function() {

   initMenu();
   initHeader();
   initEnquirePage();
   initModalIframe();

};

// Wait for DOM to be ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initApp);
} else {
    initApp();
}